import { FC } from 'react';

export const CollectIgnore: FC = (props) => (
	<svg width="20" height="18" viewBox="0 0 20 18" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M1.17279 1.65836C1.68096 0.642007 2.71975 0 3.85607 0H16.1439C17.2802 0 18.319 0.642007 18.8272 1.65836L19.6833 3.37049C19.8916 3.78706 20 4.2464 20 4.71214V15C20 16.6569 18.6569 18 17 18H3C1.34315 18 0 16.6569 0 15V4.71214C0 4.2464 0.108436 3.78706 0.316719 3.37049L1.17279 1.65836ZM3.85607 2C3.4773 2 3.13103 2.214 2.96164 2.55279L2.23803 4H17.762L17.0384 2.55279C16.869 2.214 16.5227 2 16.1439 2H3.85607ZM18 6H2V15C2 15.5523 2.44772 16 3 16H17C17.5523 16 18 15.5523 18 15V6Z"
			fill="currentColor"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M8.20107 7.79393C7.81192 7.40202 7.181 7.40202 6.79186 7.79393C6.40271 8.18583 6.40271 8.82122 6.79186 9.21313L8.59021 11.0242L6.84217 12.7846C6.45303 13.1765 6.45303 13.8119 6.84217 14.2038C7.23131 14.5957 7.86224 14.5957 8.25138 14.2038L9.99942 12.4434L11.7475 14.2038C12.1366 14.5957 12.7675 14.5957 13.1567 14.2038C13.5458 13.8119 13.5458 13.1765 13.1567 12.7846L11.4086 11.0242L13.207 9.21313C13.5961 8.82122 13.5961 8.18583 13.207 7.79393C12.8178 7.40202 12.1869 7.40202 11.7978 7.79393L9.99942 9.60502L8.20107 7.79393Z"
			fill="currentColor"
		/>
	</svg>
);
